
import { NodeType } from '@amplify/amp-module';
import { mapGetters, mapState } from 'vuex';

import Message from '../node-components/Message';
import Typing from '../common/Typing';

export default {
  components: {
    Message,
    Typing,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    stackIndex: {
      type: Number,
      default: null,
    },
    delay: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: '',
    },
    isInnerNode: {
      type: Boolean,
      default: false,
    },
    isDelayed: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState('chatbotStore', ['currentNode', 'conversationOngoing', 'stack']),
    ...mapGetters('chatbotStore', ['currentStack']),

    className() {
      return [
        'node',
        {
          'is-group': this.isGroup && !this.typing,
          'is-inner-node': this.isInnerNode,
        },
      ];
    },

    isGroup() {
      return this.type === NodeType.carousel;
    },

    typing() {
      return this.isDelayed || this.currentStack?.[this.stackIndex]?.delayed;
    },

    shouldRender() {
      // Don't render if it's a node in the past and it's still loading - as we don't handle old nodes.
      // We also render nodes without a stack index, as they are manual loading indicators.
      return this.stackIndex === null || !(this.typing && this.currentStack?.length - 1 !== this.stackIndex);
    },
  },
};
